import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const KEY = 'ce_affiliate_tracking_consent';

export default function AffiliateTracking() {
  const { user } = useAuth();
  const enabled = process.env.REACT_APP_AFFILIATE_TRACKING_ENABLED === 'true';
  const accountId = process.env.REACT_APP_FIRSTPROMOTER_ACCOUNT_ID;
  const hasReferral = new URLSearchParams(window.location.search).has('fpr');
  const [consent, setConsent] = useState(() => localStorage.getItem(KEY));
  const [showDialog, setShowDialog] = useState(() => !localStorage.getItem(KEY));

  useEffect(() => {
    if (user?.role === 'PARTNER_DEMO' || !enabled || !accountId || consent !== 'accepted') return;
    window.fpr = window.fpr || function fpr() { (window.fpr.q = window.fpr.q || []).push(arguments); };
    window.fpr('init', { cid: accountId });
    window.fpr('click');
    // Email is the common identifier with Stripe Checkout. Do not send a CE-only uid:
    // FirstPromoter expects uid to match Stripe customer identity or fp_uid.
    if (user?.email) window.fpr('referral', { email: user.email });
    if (!document.querySelector('script[data-firstpromoter]')) {
      const script = document.createElement('script');
      script.src = 'https://cdn.firstpromoter.com/fpr.js';
      script.async = true;
      script.dataset.firstpromoter = 'true';
      document.head.appendChild(script);
    }
  }, [enabled, accountId, consent, user]);

  if (user?.role === 'PARTNER_DEMO' || !enabled || !accountId || (!hasReferral && !consent)) return null;
  const clearTracking = () => {
    document.querySelector('script[data-firstpromoter]')?.remove();
    ['_fprom_ref', '_fprom_tid'].forEach((name) => {
      document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${window.location.hostname}; SameSite=Lax`;
    });
    Object.keys(localStorage).filter((key) => /^_?fprom|^fpr/i.test(key) && key !== KEY)
      .forEach((key) => localStorage.removeItem(key));
    delete window.fpr;
  };
  const decide = (value) => {
    if (value === 'rejected') clearTracking();
    localStorage.setItem(KEY, value);
    setConsent(value);
    setShowDialog(false);
  };
  if (!showDialog) return <button type="button" onClick={() => setShowDialog(true)} className="fixed bottom-3 left-3 z-40 rounded-full border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-600 shadow" aria-label="Gestisci consenso referral">Preferenze referral</button>;
  return <aside className="fixed inset-x-3 bottom-3 z-50 max-w-xl mx-auto bg-white border border-slate-200 shadow-xl rounded-2xl p-5" role="dialog" aria-label="Consenso referral">
    <p className="font-semibold text-slate-900">Misurazione del referral</p>
    <p className="text-sm text-slate-600 mt-1">Con il tuo consenso usiamo FirstPromoter per attribuire l’eventuale acquisto al partner che ti ha invitato.</p>
    <div className="flex gap-2 mt-4"><Button onClick={() => decide('accepted')} className="bg-brand text-white">Accetta</Button><Button variant="outline" onClick={() => decide('rejected')}>{consent === 'accepted' ? 'Revoca consenso' : 'Rifiuta'}</Button></div>
  </aside>;
}
